import { ArrowUpRight } from "lucide-react";
import { proxied } from "@/lib/api";

const Blogs = ({ items = [], settings = {} }) => {
  if (!items.length) return null;
  const first3 = items.slice(0, 3);
  return (
    <section id="blogs" className="bg-[#FAF6F0] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10 md:mb-14 max-w-3xl mx-auto">
          <div className="text-[#8B2323] text-xs md:text-sm tracking-[0.5em] uppercase mb-3">{settings.blogs_kicker || "Wisdom & Knowledge"}</div>
          <h2 className="font-serif italic text-4xl md:text-5xl tracking-tight text-[#C89838]">{settings.blogs_title || "From Our Blog"}</h2>
          <div className="h-[2px] w-16 bg-[#D4AF37] mt-6 mx-auto" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {first3.map((b) => (
            <a
              key={b.id}
              href={b.link || "https://rudralife.com/blog"}
              target="_blank"
              rel="noreferrer"
              data-testid={`blog-card-${b.id}`}
              data-cursor="button"
              className="group block bg-white rounded-3xl overflow-hidden border border-[rgba(45,40,37,0.08)] hover:shadow-[0_25px_50px_rgba(139,35,35,0.12)] transition-all hover:-translate-y-1"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={proxied(b.image)} alt={b.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium mb-3">
                  {b.category && <span>{b.category}</span>}
                  {b.date && <><span>·</span><span>{b.date}</span></>}
                </div>
                <h3 className="font-serif text-xl md:text-2xl text-[#2D2825] leading-tight line-clamp-2">{b.title}</h3>
                <p className="mt-3 text-sm text-[#5C544F] leading-relaxed line-clamp-3">{b.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-[#8B2323] group-hover:text-[#6B1A1A] font-semibold">
                  Read Article <ArrowUpRight size={12} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blogs;
